<template>
	<v-row justify="center">
		<v-col cols="12" lg="8" xl="6" align="center">
			<h2 class="title-underline my-5" translate>{{ $t(["ORDER STATUS"]) }}</h2>

			<v-alert
				v-model="errorMsgAlert"
				close-text="Close Alert"
				class="alert-text mb-5"
				color="error"
				dark
				dismissible
				ref="snackbarError"
			>
				{{ $t(errorMsg) }}
			</v-alert>

			<v-snackbar
				v-model="snackbar"
				class="mt-15"
				color="success"
				:snackbarTimeout="snackbarTimeout"
				top
			>
				<div class="text-center py-1" style="font-size: 16px">
					{{ $t(snackbarText) }}
				</div>

				<template v-slot:action="{ attrs }">
					<v-btn color="white" icon v-bind="attrs" @click="snackbar = false">
						<v-icon>mdi-close-circle</v-icon>
					</v-btn>
				</template>
			</v-snackbar>

			<v-row class="text-center my-3" justify="center">
				<v-icon class="mr-1" color="secondary">mdi-tshirt-crew</v-icon>
				<span class="mr-3" translate>{{ $t(["Merchandise"]) }}</span>
				<v-icon class="mr-1" color="secondary">mdi-pencil</v-icon>
				<span class="mr-3" translate>{{ $t(["Register"]) }}</span>
				<v-icon class="mr-1" color="secondary">mdi-cash</v-icon>
				<span translate>{{ $t(["Donate"]) }}</span>
			</v-row>

			<div class="text-center last-updated-text mb-3">
				<!-- <div placeholder="{{ 'Last Updated' | translate }}"></div> -->
				<span> {{ $t(["Last Updated"]) }} {{ lastUpdatedTime }} </span>
			</div>

			<v-card class="card mb-10">
				<div class="float-right pt-3 pr-3">
					<v-btn
						color="secondary"
						fab
						top
						right
						small
						:loading="refreshBtnLoading"
						@click="getAllOrders()"
					>
						<v-icon>mdi-refresh</v-icon>
					</v-btn>
				</div>

				<v-row
					class="px-8 py-5 centered-input"
					justify="center"
					style="max-width: 250px; justify-content: center"
				>
					<v-chip-group
						v-model="orderTableFilter"
						class="custom-chip-group"
						justify="center"
						active-class="primary"
						mandatory
						column
					>
						<!-- <div placeholder="{{ 'Declined' | translate }}"></div> -->
						<!-- <div placeholder="{{ 'Pending' | translate }}"></div> -->
						<!-- <div placeholder="{{ 'Ready to Complete' | translate }}"></div> -->
						<!-- <div placeholder="{{ 'Completed' | translate }}"></div> -->
						<!-- <div placeholder="{{ 'Refund' | translate }}"></div> -->
						<!-- <div placeholder="{{ 'All Records' | translate }}"></div> -->
						<v-chip filter class="fixed-chip">
							{{ $t(["Pending"]) }} ({{ filteredItems[0].length }})
						</v-chip>

						<v-chip filter class="fixed-chip">
							{{ $t(["Ready to Complete"]) }} ({{ filteredItems[1].length }})
						</v-chip>

						<!-- <v-chip filter>
              {{ $t(["Completed"]) }} ({{ filteredItems[2].length }})
            </v-chip> -->

						<v-chip filter class="fixed-chip">
							{{ $t(["All Records"]) }} ({{ filteredItems[2].length }})
						</v-chip>

						<v-chip filter class="fixed-chip">
							{{ $t(["Refund"]) }} ({{ filteredItems[3].length }})
						</v-chip>
					</v-chip-group>
				</v-row>

				<v-divider class="mb-3 mx-3"></v-divider>

				<v-row justify="center" class="px-8 pb-5">
					<!-- <div placeholder="{{ 'Search' | translate }}"></div> -->
					<div style="width: 500px" class="mt-0">
						<v-text-field
							v-model="search"
							class="centered-input mt-0"
							single-line
							hide-details
						>
							<template v-slot:label>
								{{ $t(["Search"]) }}
								<v-icon style="vertical-align: middle"> mdi-magnify </v-icon>
							</template>
						</v-text-field>
					</div>
				</v-row>

				<v-divider class="mt-3 mx-3"></v-divider>

				<template>
					<v-data-table
						class="px-3"
						v-model="selectedRow"
						item-key="id"
						mobile-breakpoint="0"
						:loading="orderTableLoading"
						:loading-text="$t(['Loading items'])"
						:no-data-text="$t(['No data available'])"
						:headers="
							orderTableFilter == 1 || orderTableFilter == 2
								? compeletedHeaders
								: orderTableFilter == 3
								? refundHeader
								: headers
						"
						:items="filteredItems[orderTableFilter]"
						:search="search"
						hide-default-footer
						disable-pagination
						@click:row="rowClick"
					>
						<template v-slot:item.type="{ item }">
							<div v-if="item.selection != undefined">
								<v-icon v-show="item.type == 'Merchandise'" color="secondary">
									mdi-tshirt-crew
								</v-icon>
								<v-icon
									v-show="
										item.selection == 'Register and/or Donate' ||
										item.selection.includes('Registration')
									"
									color="secondary"
								>
									mdi-pencil
								</v-icon>
								<v-icon
									v-show="
										item.selection == 'Register and/or Donate' ||
										item.selection.includes('Donation')
									"
									color="secondary"
								>
									mdi-cash
								</v-icon>
							</div>
						</template>

						<template v-slot:item.status="{ item }">
							<span>{{ $t(item.status) }}</span>
						</template>

						<template v-slot:item.totalText="{ item }">
							<span v-html="$t('Currency', { amount: item.totalText })" />
						</template>

						<template v-slot:item.refundAmountText="{ item }">
							<span
								v-html="
									'(' + $t('Currency', { amount: item.refundAmountText }) + ')'
								"
								class="secondary--text"
							/>
						</template>
					</v-data-table>
				</template>
			</v-card>

			<v-col cols="10" sm="8" xl="4">
				<v-btn class="btn-text" x-large block @click="backToHome()">
					{{ $t(["Back"]) }}
				</v-btn>
			</v-col>
		</v-col>
	</v-row>
</template>

<script>
import { Auth } from "aws-amplify";
import moment from "moment";

import { useAuthenicationStore } from "../../store/authenication";
import { useStatusStore } from "../../store/status";

export default {
	name: "OrderStatus",
	data: () => ({
		selectedRow: [1],
		search: "",
		orderTableFilter: 0,
		refreshBtnLoading: false,
		orderTableLoading: false,
		lastUpdatedTime: "",
		updatedTime: "",
		interval: null,
		errorMsgAlert: false,
		errorMsg: "",
		snackbar: false,
		snackbarText: "",
		snackbarTimeout: 3000,
		filteredItems: [[], [], [], [], []],
	}),
	computed: {
		headers() {
			return [
				{ text: "#", align: "start", sortable: false, value: "orderNumberId" },
				{
					text: this.$t("Phone Number"),
					sortable: false,
					value: "phoneNumber",
				},
				{ text: this.$t("Description"), sortable: false, value: "type" },
				{ text: this.$t("Status"), sortable: false, value: "status" },
			];
		},
		compeletedHeaders() {
			return [
				{
					text: "#",
					align: "start",
					sortable: false,
					value: "orderNumberId",
				},
				{
					text: this.$t("Phone Number"),
					sortable: false,
					value: "phoneNumber",
				},
				{
					text: this.$t("Last Name"),
					sortable: false,
					value: "formData.lastName",
				},
				{ text: this.$t("Description"), sortable: false, value: "type" },
				{ text: this.$t("Total"), sortable: false, value: "totalText" },
				{ text: this.$t("Status"), sortable: false, value: "status" },
			];
		},
		refundHeader() {
			return [
				{ text: "#", align: "start", sortable: false, value: "orderNumberId" },
				{
					text: this.$t("Phone Number"),
					sortable: false,
					value: "phoneNumber",
				},
				{
					text: this.$t("Last Name"),
					sortable: false,
					value: "formData.lastName",
				},
				{ text: this.$t("Description"), sortable: false, value: "type" },
				{ text: this.$t("Total"), sortable: false, value: "totalText" },
				{
					text: this.$t("Refunded"),
					sortable: false,
					value: "refundAmountText",
				},
				{ text: this.$t("Status"), sortable: false, value: "status" },
			];
		},
	},
	setup() {
		const authStore = useAuthenicationStore();
		const statusStore = useStatusStore();

		return {
			authStore,
			statusStore,
		};
	},
	destroyed() {
		clearInterval(this.interval);
	},
	mounted() {
		this.getAllOrders();

		this.snackbar = this.$route.params.success;
		this.snackbarText = this.$route.params.message;
	},
	methods: {
		async getAllOrders() {
			this.refreshBtnLoading = true;
			this.orderTableLoading = true;

			try {
				await Auth.currentSession().then(async (data) => {
					await this.statusStore
						.getAllOrdersApi(
							{
								eventName: this.authStore.runSiteInfo.eventName,
							},
							data.idToken.jwtToken
						)
						.then((response) => {
							if (response.success) {
								this.updatedTime = new Date();

								this.interval = setInterval(() => {
									let momentObject = moment(this.updatedTime).locale(
										this.$i18n.locale
									);
									this.lastUpdatedTime = momentObject.fromNow();
								}, 1000);

								let sortedTime = response.allOrders.sort((x, y) => {
									return y.modified - x.modified;
								});

								this.applyFilter(sortedTime);
							} else {
								throw response.message;
							}
						});
				});
			} catch (error) {
				this.errorMsgAlert = true;
				this.errorMsg = error.message == undefined ? error : error.message;

				this.$nextTick(() => {
					const el = this.$el.querySelector("snackbarError");
					this.$vuetify.goTo(-5, el);

					return;
				});
			}

			this.refreshBtnLoading = false;
			this.orderTableLoading = false;
		},
		applyFilter(allOrders) {
			// Pending
			this.filteredItems[0] = allOrders.filter((item) => {
				if (item.status == "Pending" || item.status == "Declined") {
					return item;
				}
			});

			// Ready to Complete
			this.filteredItems[1] = allOrders.filter((item) => {
				if (item.status == "Approved" && item.type == "Merchandise") {
					item.totalText = Number(item.formData.amount).toFixed(2);

					return item;
				}
			});

			// All Records
			this.filteredItems[2] = allOrders;

			// Refund
			this.filteredItems[3] = allOrders.filter((item) => {
				if (
					item.status != "Pending" &&
					(item.refundData.refundRequestId != null ||
						item.refundData.refundAmount.approved.total > 0)
				) {
					item.totalText = Number(item.formData.amount).toFixed(2);
					item.refundAmountText =
						item.refundData.refundAmount.approved.total.toFixed(2);

					return item;
				}
			});

			// Completed
			// this.filteredItems[2] = allOrders.filter((item) => {
			//   if (item.status == "Completed" && item.type == "Merchandise") {
			//     item.totalText = Number(item.formData.amount).toFixed(2);

			//     return item;
			//   }
			// });
		},
		rowClick(item, row) {
			// console.log(item);

			let data = item;

			this.statusStore.setOrderData(item);

			this.$router.push({
				name: "OrderStatusSummary",
				params: { data },
			});
		},
		backToHome() {
			clearInterval(this.interval);

			this.$router.push("/home");
		},
	},
};
</script>

<style lang="scss" scoped>
.last-updated-text {
	font-size: 14px;
	font-weight: bold;
}

::v-deep .custom-chip-group .v-slide-group__content {
	justify-content: center !important;
}

.fixed-chip {
	width: 180px !important;
	justify-content: center;
	text-align: center;
}
</style>
